export const SET_FIREARM_LICENCE_STATUS = 'SET_FIREARM_LICENCE_STATUS';
export const SET_FIREARM_LICENCE_LIST = 'SET_FIREARM_LICENCE_LIST';
export const SET_FIREARM_LICENCE_RECORD = 'SET_FIREARM_LICENCE_RECORD';
export const SET_FIREARM_LICENCE_APPLICATION_LIST = 'SET_FIREARM_LICENCE_APPLICATION_LIST';